
import { Component } from "nuxt-property-decorator"
import Footer from "~/mixins/footer"

@Component
export default class TheFooterFRComponent extends Footer {}
